import React, { PropTypes } from 'react';
import moment from 'moment';
import Paper from 'material-ui/Paper';

const Week = ({ week, selectedTimeSheet, onDaySelect }) => {
  if (week.length == 0) return (<div></div>);
  return (
    <div className="week-item first-week">
      <div className="week-number">semaine {moment(week[0].date).week()}</div>
      {week.map((day) => {
        let className = 'timeline-day';
        className += (day.date == selectedTimeSheet.date) ? ' paper-active' : '';
        return (
          <Paper key={day.id} day={day} className={className} zDepth={1} onClick={()=>onDaySelect(day)}>
            <h6 style={{ marginBottom: 0 }}>{moment(day.date).format('ddd')}</h6>
            <h5 style={{
              marginTop: 0,
              fontWeight: 'bold',
              marginBottom: 0
            }}>{moment(day.date).format('D')}</h5>
            <h6 style={{ marginTop: 0 }}>{moment(day.date).format('MMMM')}</h6>
          </Paper>
        );
      })}
    </div>
  );
};

Week.propTypes = {
  week: PropTypes.array.isRequired,
  selectedTimeSheet: PropTypes.object,
  onDaySelect: PropTypes.func.isRequired
};

export default Week;


/** WEBPACK FOOTER **
 ** ./src/components/Timeline/Week.js
 **/